import "./DatasetScoring.scss";

import { CCardImg, CCol, CJumbotron, CRow } from "@coreui/react";
import {
  DataScoringStep,
  DataSelectStep,
  MapDatasetStep,
  ScoreDatasetStep,
} from "./DatasetScoringModel";
//import ProgressStages from "../buttons/progressStages/ProgressStages";
import {
  getSourceDataRecords,
  useDatasetList,
  useInfiniteAllSourceDataRecords,
  useUnscoredQueue,
} from "../datasets/services/DatasetServices";
import React, { useEffect, useState } from "react";

import { CreateDatasetModal } from "../forms/datasetModels/CreateDatasetModal";
import {
  useAssociateNewModelDataset,
  useGetModels,
} from "../models/ModelService";
import { determineLoginPlatformType } from "src/reusable/Functions";

export default function StepList() {
  const step_details = [
    {
      name: "Select Data for Scoring and Analysis",
      step_number: 0,
      step_short_description: "",
      step_description:
        "Select a dataset that you would like to score. The dataset should have data that matches the models input. Alternatively, you can upload a file to score new data.",
    },
    {
      name: "Select Model Version for Scoring",
      step_short_description: "",
      step_number: 1,
      step_description:
        "Select a model that you would like to use to score your data. The model should have inputs that line with the dataset you selected. If you don&apos;t have a model, you can create one in the Model Management section. Then, select a version of the model youd like to use.",
    },
    {
      name: "Map Data to Model Inputs",
      step_short_description: "",
      step_number: 2,
      step_description:
        "Map the inputs of the model to the corresponding fields in the dataset. Make sure that the type of data matches, ie. text to text, number to number, etc.",
    },
    {
      name: "Score Dataset and Analyze Outputs",
      step_number: 3,
      step_short_description: "",

      step_description:
        "Score your dataset. The model will input the data youve mapped and start to produce results that you can analyze! Scoring a large dataset may take a while, so feel free to close the window and come back.",
    },
  ];

  const [dataset, setDataset] = useState({ name: "", id: 0 });
  const [successProgress, setSuccessProgress] = useState(0);
  const [modelCur, setModel] = useState("");
  const [modelVersion, setModelVersion] = useState([]);
  const [currentModelVersion, setCurrentModelVersion] = useState(0);
  const [visibleCreateDataset, setVisibleCreateDataset] = useState(false);
  const [successScore, setSuccessScore] = useState(0);
  const [isVisibleUpload, setIsVisibleUpload] = useState(false);
  const [sourceDataRecords, setSourceDataRecords] = useState(null);
  const [mapStatus, setMapStatus] = useState(null);

  const { data: datasetList } = useDatasetList();
  const { data: modelList } = useGetModels(null);

  useEffect(() => {
    if (dataset.name === "Create new...") {
      setVisibleCreateDataset(true);
    } else {
      setVisibleCreateDataset(false);
    }
    setModel("");
    setModelVersion([]);
    setCurrentModelVersion(0);
    setSuccessScore(0);
    setSourceDataRecords(null);
    setMapStatus(null);
  }, [dataset]);

  useEffect(() => {
    setCurrentModelVersion(0);
  }, [modelCur]);

  const { data: unscoredDataStats } = useUnscoredQueue(
    dataset.id,
    (modelVersion &&
      modelVersion.find(
        (item) => item.version_number === currentModelVersion,
      ) &&
      modelVersion.find((item) => item.version_number === currentModelVersion)
        .id) ||
      "",
    true,
  );

  const denominator =
    unscoredDataStats?.scoring +
    unscoredDataStats?.waiting +
    unscoredDataStats?.scored +
    unscoredDataStats?.saving +
    unscoredDataStats?.complete;

  const onChangeModel = (data) => {
    setModel(data);
  };
  const onChangeModelVersion = (data) => {
    setModelVersion(data);
  };
  const onChangeCurrentModelVersion = (data) => {
    setCurrentModelVersion(data);
  };

  const { data: sourceData } = useInfiniteAllSourceDataRecords(dataset.id);

  useEffect(() => {
    setSourceDataRecords(sourceData);
  }, [sourceData]);

  const setSourceData = (datasetId) => {
    getSourceDataRecords(datasetId).then((data) =>
      setSourceDataRecords((state) => ({ ...state, pages: [data] })),
    );
  };

  const { mutate: addAssociation } = useAssociateNewModelDataset();

  const handleSubmit = async (model_id, datasetId) => {
    datasetId = String(datasetId);
    try {
      await addAssociation({ model_id, datasetId });
    } catch (error) {
      console.log(error);
    }
  };

  const versions = [...modelVersion].reverse();

  useEffect(() => {
    let score = 0;
    if (sourceDataRecords && sourceDataRecords.pages[0].length > 0) {
      score += 1;
      if (
        modelCur !== "Create new..." &&
        modelCur.length > 0 &&
        currentModelVersion !== 0 &&
        modelVersion &&
        versions.filter((item, index) => {
          return index + 1 === currentModelVersion;
        })[0]?.is_deployed
      ) {
        score += 1;
        if (mapStatus === 200) {
          score += 1;
          if (
            unscoredDataStats &&
            unscoredDataStats.complete &&
            denominator &&
            unscoredDataStats.complete === denominator
          ) {
            score += 1;
          }
        }
      }
    }
    setSuccessProgress(score);
  }, [
    dataset,
    modelCur,
    currentModelVersion,
    sourceDataRecords,
    successScore,
    mapStatus,
  ]);

  const onChangeDataset = async (data) => {
    setDataset(data);
    await getSourceDataRecords(data.id).then((_data) => {
      if (_data.length < 1) {
        setIsVisibleUpload(true);
      }
    });
  };

  useEffect(() => {
    setMapStatus(null);
  }, [currentModelVersion]);
  return (
    <>
      <CreateDatasetModal
        isVisible={visibleCreateDataset}
        onClose={() => {
          setVisibleCreateDataset(false);
          setDataset({ name: "", id: 0 });
        }}
        onCreated={(ds) => setDataset({ name: ds.name, id: ds.id })}
      />

      <div style={{ position: "relative" }}>
        <CJumbotron
          data-testid="ds-scoring-header"
          style={{ padding: "12px 16px", margin: "0 15px 0 15px" }}
        >
          <CRow>
            <CCol sm="12" style={{ display: "flex", alignItems: "center" }}>
              <CCardImg
                className="rounded mprops.modelx-auto d-block card-img-top"
                variant="full"
                src={"/images/product-logos/wrkmgmt.png"}
                shape="rounded"
                style={{ height: "100px", width: "100px", float: "left" }}
              />
              <CRow>
                <div style={{ marginLeft: "15px" }}>
                  <h3 className="display-6" data-testid="ds-scoring-heading">
                    Dataset Scoring
                  </h3>
                  <span style={{ marginLeft: "1px" }}>
                    {`This common workflow helps you upload and score new data
                    with a ${determineLoginPlatformType()} Model. The scored data can then be used in a
                    bucket for further analysis.`}
                  </span>
                </div>
              </CRow>
            </CCol>
          </CRow>
        </CJumbotron>

        {step_details && (
          <div
            data-testid="ds-scoring-steps"
            style={{
              background: " #e8e8e8",
              borderRadius: "10px",
              padding: "1px",
              margin: "15px",
            }}
          >
            <DataSelectStep
              {...step_details[0]}
              testId="ds-scoring-step-data-select"
              collapsed={step_details[0].step_number > successProgress}
              canCollapsed={step_details[0].step_number > successProgress}
              successProgress={successProgress}
              ifCheckedStep={successProgress > 0}
              dataset={dataset}
              datasetList={datasetList}
              onChangeDataset={onChangeDataset}
              sourceDataRecords={sourceDataRecords}
              isVisibleUpload={isVisibleUpload}
              setIsVisibleUpload={() => setIsVisibleUpload(false)}
              setSourceData={setSourceData}
            />
            <DataScoringStep
              {...step_details[1]}
              testId="ds-scoring-step-model-select"
              collapsed={step_details[1].step_number > successProgress}
              canCollapsed={step_details[1].step_number > successProgress}
              successProgress={successProgress}
              ifCheckedStep={successProgress > 1}
              modelCur={modelCur}
              modelList={modelList}
              onChangeModelVersion={onChangeModelVersion}
              onChangeModel={onChangeModel}
              onChangeCurrentModelVersion={onChangeCurrentModelVersion}
              currentModelVersion={currentModelVersion}
              modelVersion={versions}
              handleSubmit={handleSubmit}
              dataset={dataset}
            />
            <MapDatasetStep
              {...step_details[2]}
              testId="ds-scoring-step-map-dataset"
              collapsed={step_details[2].step_number > successProgress}
              canCollapsed={step_details[2].step_number > successProgress}
              successProgress={successProgress}
              step_number={step_details[2].step_number}
              ifCheckedStep={successProgress > 2}
              modelList={modelList}
              modelCur={modelCur}
              dataset={dataset}
              modelVersion={[...modelVersion].reverse()}
              currentModelVersion={currentModelVersion}
              setMapStatus={(status) => setMapStatus(status)}
            />
            <ScoreDatasetStep
              {...step_details[3]}
              testId="ds-scoring-step-score-dataset"
              collapsed={step_details[3].step_number > successProgress}
              canCollapsed={step_details[3].step_number > successProgress}
              successProgress={successProgress}
              ifCheckedStep={successProgress > 3}
              dataset={dataset}
              currentModelVersionScore={
                (modelVersion &&
                  modelVersion.find(
                    (item) => item.version_number === currentModelVersion,
                  ) &&
                  modelVersion.find(
                    (item) => item.version_number === currentModelVersion,
                  ).id) ||
                ""
              }
              setSuccessScore={(success) => setSuccessScore(success)}
              modelVersion={
                modelVersion &&
                modelVersion.find(
                  (item) => item.version_number === currentModelVersion,
                )
              }
            />
          </div>
        )}
      </div>
    </>
  );
}

StepList.propTypes = {};
